import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import Image from "next/legacy/image";
import Header from '../../../components/ui-v2/header/header.component';
import { useStyles } from '../../../utils/hooks/useStyles';
import AppStoreButtons from '../../ui-v2/app-store-buttons/app-store-buttons.component';
import ImageWrapper from '../../images/Image-wrapper';
import getAppPhonesImage from '../../../public/assets/images/get-app-phones.webp';
import { downloadPageStyles } from './download-page.styles';

const DownloadPage: FC = () => {
	const styles = useStyles(downloadPageStyles);

	return (
		<Box sx={styles.root}>
			<Header />

			<Box sx={styles.background}>
				<Box sx={styles.content}>
					<Box sx={styles.text}>
						<Typography sx={styles.title}>
							SweatPals app connects <br /> you to the local fitness <br /> wellness events, <br /> communities &
							people.
						</Typography>
						<AppStoreButtons />
					</Box>
					<ImageWrapper sx={styles.phonesImageWrapper}>
						<Image src={getAppPhonesImage} alt="phones" />
					</ImageWrapper>
				</Box>
			</Box>
		</Box>
	);
};

export default DownloadPage;
